import ModalWrapper from 'Components/Modals/ModalWrapper'
import React, { useEffect, useState } from 'react'
import { FormGroup, Input, Label, Row, Col, Button } from 'reactstrap';

interface Product {
  id: number;
  product_name: string;
  related_products?: Product[];
}

interface RelatedProduct {
    child_product_id: number;
}

interface LinkProductsModalProps {
  isOpen: boolean;
  toggle: () => void;
  product: Product;
  products: Product[];
  onSave: (data: { related_products: RelatedProduct[] }) => void;
}

function LinkProductsModal({ isOpen, toggle, product, products, onSave }: LinkProductsModalProps) {
  const [selectedProducts, setSelectedProducts] = useState<number[]>([]);

  useEffect(() => {
    if (product?.related_products) {
      setSelectedProducts(product?.related_products.map(p => p.id));
    }
  }, [product]);

  const handleCheckboxChange = (productId: number) => {
    setSelectedProducts(prev => {
      if (prev.includes(productId)) {
        return prev.filter(id => id !== productId);
      } else {
        return [...prev, productId];
      }
    });
  };

  const handleSave = () => {
    const relatedProducts = selectedProducts.map(id => ({ child_product_id: id }));
    onSave({related_products: relatedProducts});
    toggle();
  };

  return (
    <ModalWrapper
      show={isOpen}
      onCloseClick={toggle}
      title="Link Related Products"
      body={
        <>
          <div className="my-4">
            <h6>{product?.product_name}</h6>
            <p className="text-muted">Select products that are related to or commonly purchased with this product.</p>
          </div>
          <div className="products-list">
            <Row>
              {products.filter(p => p.id !== product?.id).map((p) => (
                <Col md={6} key={p.id} className="mb-2">
                  <FormGroup check className="mb-2">
                    <Input
                      type="checkbox"
                      id={`product-${p.id}`}
                      checked={selectedProducts.includes(p.id)}
                      onChange={() => handleCheckboxChange(p.id)}
                      className="form-check-input"
                    />
                    <Label check htmlFor={`product-${p.id}`} className="form-check-label">
                      {p.product_name}
                    </Label>
                  </FormGroup>
                </Col>
              ))}
            </Row>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button color="secondary" className="me-2" onClick={toggle}>Cancel</Button>
            <Button color="primary" onClick={handleSave}>Save Changes</Button>
          </div>
        </>
      }
    />
  )
}

export default LinkProductsModal
